import { Injectable } from '@angular/core';
import { Observable, of, startWith } from 'rxjs';
import { Asset } from './asset.dto';
import { ChangeTyped, SearchResult } from '@damofire/data-commons';
import { TypedDesQuery } from '../des.dto';
import { ObservableNoteableService } from '../note/noteable-observable.service';
import { ObservableNoteService } from '../note/note-observable.service';
import { Note, Noteable } from '../note/note.dto';

export const ASSET_SEARCH_FIELDS = ['clientCode', 'section', 'description'];

@Injectable()
export abstract class ObservableAssetService extends ObservableNoteableService<Asset> {
  protected readonly SEARCH_FIELDS = ASSET_SEARCH_FIELDS;
  protected readonly notesFilterFn = (note: Note, asset: Noteable): boolean => asset._id === note.asset._id;

  protected constructor(protected readonly observableNoteService: ObservableNoteService) {
    super(observableNoteService);
  }

  protected abstract observeById(divisionId: string, id: string): Observable<ChangeTyped<Asset>>;
  abstract observeBySection(divisionId: string, section: string): Observable<ChangeTyped<Asset>[]>;
  abstract observeBySystem(divisionId: string, system: number): Observable<ChangeTyped<Asset>[]>;

  search(id: string, sQuery: TypedDesQuery, forceNoteInspectionId?: string): Observable<SearchResult<Asset>> {
    return super.searchByInspection(id, sQuery, forceNoteInspectionId);
  }

  observeAsset(divisionId: string, assetId: string, inspectionId?: string): Observable<ChangeTyped<Asset>> {
    const noteableSub = this.observeById(divisionId, assetId);
    let noteSub: Observable<Note[]> = of([]);
    if (inspectionId) {
      noteSub = this.observableNoteService.observeNotes(divisionId, inspectionId, assetId).pipe(startWith([]));
    }
    return this.combineNoteableNotes(noteSub, noteableSub);
  }
}
